import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

const kudosById = '/kudos/:id';
const kudosComment = '/kudos_comment/';
const kudosCommentById = '/kudos_comment/:id';

export async function getKudosRequest(id) {
  return await api.get(generatePath(kudosById, { id }), config('json'));
}

export async function editKudosRequest({ note, id }) {
  return await api.patch(
    generatePath(kudosById, { id }),
    { note: note },
    config('json')
  );
}

export async function getKudosCommentListRequest(kudos_id) {
  const response = await api.get(kudosComment, config('json', { kudos_id }));
  return response.data;
}

export async function getKudosReplyCommentListRequest(kudos_id, root_id) {
  const response = await api.get(
    kudosComment,
    config('json', { kudos_id, root_id })
  );
  return response.data;
}

export async function getKudosLikeListRequest(kudos_id) {
  const response = await api.get(`/kudos_like/${kudos_id}`, config('json'));
  return response.data;
}

export async function sendCommentRequest({
  kudos_id,
  comment,
  parent_id = null
}) {
  return await api.post(
    kudosComment,
    { kudos_id, comment, parent_id },
    config('json')
  );
}

export async function deleteCommentRequest({ id }) {
  return await api.delete(
    generatePath(kudosCommentById, { id }),
    config('json')
  );
}

export async function editCommentRequest({ comment, id }) {
  return await api.patch(
    generatePath(kudosCommentById, { id }),
    { comment: comment },
    config('json')
  );
}
